"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
const jwt_decode_1 = require("jwt-decode");
const authorizeAccessToken = (token, options) => {
    const { sub: sportnetId, aud: app, azp: ppo, rls: roles, } = (0, jwt_decode_1.jwtDecode)(token);
    if (!!(options === null || options === void 0 ? void 0 : options.ppo) && ppo !== (options === null || options === void 0 ? void 0 : options.ppo)) {
        throw new errors_1.RESTErrorUnauthorized('UNAUTHORIZED_PPO', `This access token wasn't issued for appSpace ${options === null || options === void 0 ? void 0 : options.ppo}`);
    }
    if (!!(options === null || options === void 0 ? void 0 : options.app) && !!sportnetId && app !== (options === null || options === void 0 ? void 0 : options.app)) {
        throw new errors_1.RESTErrorUnauthorized('UNAUTHORIZED_APP', `This access token wasn't issued for app ${options === null || options === void 0 ? void 0 : options.app}`);
    }
    // skontrolujeme rolu
    if (!!(options === null || options === void 0 ? void 0 : options.roles)) {
        // pohladame vsetky definovane role
        for (const [requiredRoleApp, requiredRole] of Object.entries(options.roles)) {
            const tokenAppRole = (roles || {})[requiredRoleApp];
            if (requiredRole !== true && tokenAppRole !== requiredRole) {
                throw new errors_1.RESTErrorUnauthorized('UNAUTHORIZED_ROLE', `This access token does not include required role ${requiredRoleApp}:${requiredRole}`);
            }
        }
    }
};
exports.default = authorizeAccessToken;
